import * as AST from "../parse/sfml-ast";

export const isSupportedItemType = (itemType: string): boolean =>
  ["flyer-item", "ecom-item", "coupon"].includes(itemType);



// WEBPACK FOOTER //
// webpack://SFMLWeb/src/utils/item-type-checker.ts